import React, { useState, useEffect } from "react";
import UserTable from "../components/user/UserTable";
import UserPopup from "../components/user/UserPopup";
import jwtAxios from "../apiAxios/axios";

function User() {
  const [users, setUsers] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Users from API
  const fetchUsers = async () => {
    try {
      setLoading(true); // Start loading
      const response = await jwtAxios.get("/users/list");
      setUsers(response.data);
    } catch (error) {
      setError("Failed to load users. Please try again later.");
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Open Popup for Creating a User
  const handleCreateUser = () => {
    setCurrentUser(null); // Reset current user
    setShowPopup(true);
  };

  // Open Popup for Editing a User
  const handleEditUser = (user) => {
    setCurrentUser(user); // Set the selected user for editing
    setShowPopup(true);
  };

  // Close Popup
  const handleClosePopup = () => {
    setShowPopup(false);
    setCurrentUser(null);
  };

  // Save User (Create or Update)
  const handleSaveUser = async (user) => {
    try {
      if (user.id) {
        // Update existing user
        const response = await jwtAxios.put(`/users/update/${user.id}`, user);
        const updatedUser = response.data.user;

        setUsers((prev) =>
          prev.map((u) => (u.id === user.id ? updatedUser : u))
        );
      } else {
        // Add new user
        const response = await jwtAxios.post("/users/create", user);
        const newUser = response.data.user;

        setUsers((prev) => [...prev, newUser]);
      }
      setShowPopup(false);
    } catch (error) {
      console.error("Error saving user:", error);
      alert(error.response?.data?.error || "Something went wrong.");
    }
  };

  return (
    <div className="p-6 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">User Management</h1>
        <button
          onClick={handleCreateUser}
          className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-1"
        >
          Create User
        </button>
      </div>

      {/* Error Handling */}
      {error && (
        <div className="bg-red-100 text-red-700 px-4 py-2 rounded-lg mb-4">
          {error}
        </div>
      )}

      {/* Loading State */}
      {loading ? (
        <div className="text-center text-gray-600">Loading users...</div>
      ) : (
        <>
          {/* User Table */}
          {users.length > 0 ? (
            <UserTable users={users} onEdit={handleEditUser} />
          ) : (
            <div className="text-center text-gray-600">
              No users found. Click "Create User" to add new users.
            </div>
          )}
        </>
      )}

      {/* User Popup */}
      {showPopup && (
        <UserPopup
          user={currentUser}
          onClose={handleClosePopup}
          onSave={handleSaveUser}
        />
      )}
    </div>
  );
}

export default User;
